import React, { Component } from 'react'
import './App.css'
import {
  Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom'
import swal from 'sweetalert'

// - page
import LoginRegister from './page/login_register'
import HomeMAgent from './page/home_magent'
import Page404 from './page/page_404'

// -

import { history } from './helper/history';
import localdata from './helper/localdata';

const ProtectedRoute = ({ isAllowed, ...props }) =>
  isAllowed === 1 ? <Route {...props} /> : <Redirect to="/login" />;

class App extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    
  }

  render() {
    return (
      <Router history={history}>
        <Switch>
          <Route exact path="/login" component={LoginRegister} />
          <Route exact path="/master" component={HomeMAgent} />
          <Route path="*" component={Page404} />
        </Switch>
      </Router>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js